import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Download, ExternalLink } from 'lucide-react';

const QRCodePage = () => {
  const serviceMenuUrl = `${window.location.origin}/services-menu`;

  const downloadQRCode = () => {
    const svg = document.getElementById('qr-code-svg');
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');
      
      const downloadLink = document.createElement('a');
      downloadLink.download = 'ayumi-suzuki-services-menu-qr.png';
      downloadLink.href = pngFile;
      downloadLink.click();
    };
    
    img.src = 'data:image/svg+xml;base64,' + btoa(svgData);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 via-white to-rose-50 py-12 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-serif text-gray-800 mb-2">Services Menu QR Code</h1>
          <p className="text-gray-600">Scan to view our complete services menu</p>
        </div>

        {/* QR Code Display */}
        <div className="bg-white rounded-3xl shadow-2xl p-12 mb-8">
          <div className="flex justify-center mb-6">
            <QRCodeSVG
              id="qr-code-svg"
              value={serviceMenuUrl}
              size={300}
              level="H"
              includeMargin={true}
              bgColor="#ffffff"
              fgColor="#0d9488"
            />
          </div>
          
          <div className="text-center">
            <p className="text-sm text-gray-600 mb-4">Scan with your phone camera</p>
            <div className="bg-teal-50 rounded-lg p-4 mb-6">
              <p className="text-xs text-gray-700 break-all">{serviceMenuUrl}</p>
            </div>
            
            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={downloadQRCode}
                className="inline-flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
              >
                <Download className="w-5 h-5 mr-2" />
                Download QR Code
              </button>
              
              <a
                href="/services-menu"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-gray-800 hover:bg-gray-900 text-white px-6 py-3 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
              >
                <ExternalLink className="w-5 h-5 mr-2" />
                View Services Menu
              </a>
            </div>
          </div>
        </div>

        {/* Instructions */}
        <div className="bg-white rounded-2xl p-8 shadow-lg">
          <h2 className="text-2xl font-serif text-gray-800 mb-4">How to Use</h2>
          <ul className="space-y-3 text-gray-700">
            <li className="flex items-start">
              <span className="bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 flex-shrink-0 mt-0.5">1</span>
              <span>Download the QR code image using the button above</span>
            </li>
            <li className="flex items-start">
              <span className="bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 flex-shrink-0 mt-0.5">2</span>
              <span>Print it on your business cards, flyers, or display at your location</span>
            </li>
            <li className="flex items-start">
              <span className="bg-teal-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-3 flex-shrink-0 mt-0.5">3</span>
              <span>Customers scan with their phone to instantly view your services menu</span>
            </li>
          </ul>
        </div>

        {/* Back to Home */}
        <div className="text-center mt-8">
          <a
            href="/"
            className="text-teal-600 hover:text-teal-700 font-medium hover:underline"
          >
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
};

export default QRCodePage;
